export default "__VITE_ASSET__CFucR0nz__"